import { c as _c } from "react/compiler-runtime";
// /s/<код> - ссылка магазина для его клиентов (клиенты продавцов, 17.10.2026).
//
// Запоминаем код на устройстве (30 дней, первое касание) и сразу открываем
// витрину этого магазина. Покупателю ничего не показываем: привязка случится
// при входе (lib/use-shop-invite.ts). Неизвестный код - на главную.
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { api } from "@/api";
import { Skeleton } from "@osmix/ui/skeleton";
import { referralMetaOf } from "@/lib/referral-meta";
import { rememberShopInvite } from "@/lib/shop-invite";
export function ShopInvitePage() {
  const $ = _c(6);
  const {
    code: t0
  } = useParams();
  const code = t0 === undefined ? "" : t0;
  const navigate = useNavigate();
  const {
    search
  } = useLocation();
  let t1;
  let t2;
  if ($[0] !== code || $[1] !== navigate || $[2] !== search) {
    t1 = () => {
      let cancelled = false;
      api.shopInvite.resolve(code).then(invite => {
        if (cancelled) {
          return;
        }
        if (!invite) {
          navigate("/", {
            replace: true
          });
          return;
        }
        rememberShopInvite(invite.code, referralMetaOf(search));
        navigate(`/shop/${encodeURIComponent(invite.slug)}${search}`, {
          replace: true
        });
      }).catch(() => {
        if (!cancelled) {
          navigate("/", {
            replace: true
          });
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t2 = [code, navigate, search];
    $[0] = code;
    $[1] = navigate;
    $[2] = search;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-4 px-4 py-8" aria-busy="true"><Skeleton className="h-40 w-full rounded-2xl" /><Skeleton className="h-6 w-1/3" /></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}